import { DropDownList } from '@progress/kendo-react-dropdowns'
import { useComponentProperties, useFetchedValues } from '../../../../Hooks/Display/useComponentProperties';
import { ATTRIBUTE_LABEL } from '../../../Helpers/Labels/AttributeLabel';
import { useEffect, useState } from 'react';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import { useTranslation } from 'react-i18next';

function MappingAttributeForm() {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();
    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [mappingAttributes, setMappingAttributes] = useState([]);

    const { t } = useTranslation("display/components/calendar");

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const mappingAttributes = fetchedValues.attributes
                .filter(attribute =>
                    (attribute.attributeType === "DateTime" && attribute.dateTimeType !== "time") ||
                    (attribute.attributeType === "Mirror" && attribute.attribute.attributeType === "DateTime" && attribute.attribute.dateTimeType !== "time")
                )
                .sort((a, b) => a.attributeName.localeCompare(b.attributeName));
            setMappingAttributes(mappingAttributes)
        }
    }, fetchedValues.attributes)

    function handleStartAttribute(e) {
        let endAttr = properties.endAttribute
        if (e.target.value._id === "") {
            endAttr = mappingAttributes[0];
        }
        if (e.target.value.dateTimeType === "date") {
            endAttr = e.target.value
        }
        if (e.target.value.dateTimeType === "datetime") {
            endAttr = e.target.value
        }
        setProperty("startDateAttribute", e.target.value)
        setProperty("endDateAttribute", endAttr)
    }

    function handleEndAttribute(e) {
        debugger;
        setProperty("endDateAttribute", e.target.value)
    }

    function filterStartAttribute() {
        const systemAttributes = mappingAttributes.filter((attr) =>
            attr.isSystemAttribute
        ).sort((a, b) => a.attributeName.localeCompare(b.attributeName));
        const normalAttributes = mappingAttributes.filter((attr) =>
            !attr.isSystemAttribute
        ).sort((a, b) => a.attributeName.localeCompare(b.attributeName));

        return [...normalAttributes, ...systemAttributes]
    }

    function filterEndAttribute() {
        let attributes = mappingAttributes;
        if (properties.startAttribute && properties.startAttribute.dateTimeType === "datetime") {
            attributes = attributes.filter(attribute => attribute.dateTimeType === "datetime")
        }
        if (properties.startAttribute && properties.startAttribute.dateTimeType === "date") {
            attributes = attributes.filter(attribute => attribute.dateTimeType === "date")
        }

        const systemAttributes = attributes.filter((attr) =>
            attr.isSystemAttribute
        ).sort((a, b) => a.attributeName.localeCompare(b.attributeName));
        const normalAttributes = attributes.filter((attr) =>
            !attr.isSystemAttribute
        ).sort((a, b) => a.attributeName.localeCompare(b.attributeName));

        return [...normalAttributes, ...systemAttributes]
    }

    return (
        <>
            {
                mappingAttributes && mappingAttributes.length > 0 ?
                    <>
                        <div className="d-inline-block me-2">
                            <div className="form-label">
                                {t("form_labels.mapping_attributes.start_property")}
                            </div>
                            <DropDownList
                                style={{ width: "200px" }}
                                disabled={selectedComponent.hidden}
                                onChange={handleStartAttribute}
                                value={properties.startDateAttribute}
                                textField='attributeName'
                                dataItemKey='_id'
                                data={filterStartAttribute()}
                            />
                        </div>
                        <div className="d-inline-block me-2">
                            <div className="form-label">
                                {t("form_labels.mapping_attributes.end_property")}
                            </div>
                            <DropDownList
                                style={{ width: "200px" }}
                                disabled={selectedComponent.hidden}
                                onChange={handleEndAttribute}
                                value={properties.endDateAttribute}
                                textField='attributeName'
                                dataItemKey='_id'
                                data={filterEndAttribute()}
                            />
                        </div>
                    </>
                    :
                    <div>
                        {t("form_labels.mapping_attributes.no_properties_error")}
                    </div>
            }
        </>
    )
}

export default MappingAttributeForm;